export default __webpack_public_path__ + "static/media/envelope.8a1389f5.svg";